// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__1XBPt","ButtonLoginPage":"Button_ButtonLoginPage__JOMIV"};